export default "__VITE_ASSET__l07vBfAp__"